import { HeartPulse, Users, Baby, Microscope } from "lucide-react";

const CATEGORIES = [
  {
    id: "zdrowie",
    icon: HeartPulse,
    title: "Diagnostyka Zdrowia",
    desc: "Szukanie przyczyn dolegliwości",
    img: "/assets/nuuma_cells_11.webp",
  },
  {
    id: "match",
    icon: Users,
    title: "Secure Match",
    desc: "Zgodność genetyczna partnerów",
    img: "/assets/nuuma-ring-3.webp",
  },
  {
    id: "natal",
    icon: Baby,
    title: "Secure Natal",
    desc: "Bezpieczna ciąża (NIPT)",
    img: "/assets/nuuma_cells_05.webp",
  },
  {
    id: "ivf",
    icon: Microscope,
    title: "Genetyka Reprodukcyjna",
    desc: "Eksperckie wsparcie IVF",
    img: "/assets/nuuma_cells_08.webp",
  },
];

export default function CategoryNav() {
  return (
    <div id="segmenty" data-testid="category-nav" className="relative z-20 scroll-mt-[220px]">
      <div className="nuuma-container -mt-[120px]">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-[20px]">
          {CATEGORIES.map((cat) => {
            const Icon = cat.icon;
            return (
              <a
                key={cat.id}
                href={`#${cat.id}`}
                data-testid={`category-card-${cat.id}`}
                className="group relative flex flex-col bg-white rounded-[50px] shadow-nuuma-m border-t-[5px] border-nuuma-secondary hover:-translate-y-1.5 hover:shadow-[0_20px_40px_rgba(41,33,104,0.14)] transition-all duration-300 overflow-hidden"
              >
                <div className="p-7 pb-6">
                  <div className="h-11 w-11 rounded-xl bg-nuuma-primary/5 flex items-center justify-center mb-4 group-hover:bg-nuuma-secondary/10 transition-colors">
                    <Icon className="h-5 w-5 text-nuuma-primary group-hover:text-nuuma-secondary transition-colors" />
                  </div>
                  <h3 className="font-display font-bold text-nuuma-primary text-lg leading-tight">
                    {cat.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-nuuma-grey700">{cat.desc}</p>
                </div>

                {/* Edge-to-edge image — bottom-most element */}
                <div className="mt-auto aspect-[4/3] overflow-hidden rounded-t-[50px]">
                  <img
                    src={cat.img || "/assets/nuuma-lenses.webp"}
                    alt=""
                    aria-hidden="true"
                    loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </div>
  );
}
